import { render } from "./DashboardMargin.vue?vue&type=template&id=6881868d&scoped=true"
import script from "./DashboardMargin.vue?vue&type=script&lang=js"
export * from "./DashboardMargin.vue?vue&type=script&lang=js"

import "./DashboardMargin.vue?vue&type=style&index=0&id=6881868d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6881868d"]])

export default __exports__